module.exports = __webpack_public_path__ + "img/13.38f3dfef.png";